import { render, staticRenderFns } from "./china.vue?vue&type=template&id=0625a102&scoped=true&"
import script from "./china.vue?vue&type=script&lang=js&"
export * from "./china.vue?vue&type=script&lang=js&"
import style0 from "./china.vue?vue&type=style&index=0&id=0625a102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0625a102",
  null
  
)

export default component.exports